import al from './flags-icons/albania.svg';
import za from './flags-icons/south-africa.svg';
import arl from './flags-icons/arab-league.svg';
import dz from './flags-icons/algeria.svg';
import bh from './flags-icons/bahrain.svg';
import eg from './flags-icons/egypt.svg';
import iq from './flags-icons/iraq.svg';
import jo from './flags-icons/jordan.svg';
import kw from './flags-icons/kuwait.svg';
import lb from './flags-icons/lebanon.svg';
import ly from './flags-icons/libya.svg';
import ma from './flags-icons/morocco.svg';
import om from './flags-icons/oman.svg';
import qa from './flags-icons/qatar.svg';
import sa from './flags-icons/saudi-arabia.svg';
import sy from './flags-icons/syria.svg';
import eu from './flags-icons/basque.svg';
import tn from './flags-icons/tunisia.svg';
import ae from './flags-icons/uae.svg';
import ye from './flags-icons/yemen.svg';
import hk from './flags-icons/hong-kong.svg';
import hr from './flags-icons/croatia.svg';
import cn from './flags-icons/china.svg';
import sg from './flags-icons/singapore.svg';
import tw from './flags-icons/taiwan.svg';
import by from './flags-icons/belarus.svg';
import bg from './flags-icons/bulgaria.svg';
import est from './flags-icons/estelada.svg';
import us from './flags-icons/united-states.svg';
import au from './flags-icons/australia.svg';
import bz from './flags-icons/belize.svg';
import ca from './flags-icons/canada.svg';
import ie from './flags-icons/ireland.svg';
import jm from './flags-icons/jamaica.svg';
import gb from './flags-icons/united-kingdom.svg';
import nz from './flags-icons/new-zealand.svg';
import be from './flags-icons/belgium.svg';
import cz from './flags-icons/czech-republic.svg';
import dk from './flags-icons/denmark.svg';
import nl from './flags-icons/nederland.svg';
import tt from './flags-icons/trinidad.svg';
import fi from './flags-icons/finland.svg';
import af from './flags-icons/afghanistan.svg';
import ee from './flags-icons/estonia.svg';
import ir from './flags-icons/iran.svg';
import fr from './flags-icons/france.svg';
import pk from './flags-icons/pakistan.svg';
import tj from './flags-icons/tajikistan.svg';
import uz from './flags-icons/uzbekistan.svg';
import lu from './flags-icons/luxembourg.svg';
import at from './flags-icons/austria.svg';
import de from './flags-icons/germany.svg';
import gr from './flags-icons/greece.svg';
import hu from './flags-icons/hungary.svg';
import is from './flags-icons/iceland.svg';
import il from './flags-icons/israel.svg';
import li from './flags-icons/liechtenstein.svg';
import gd from './flags-icons/scotland.svg';
import ch from './flags-icons/switzeland.svg';
import am from './flags-icons/armenia.svg';
import az from './flags-icons/azerbaijan.svg';
import ge from './flags-icons/georgia.svg';
import id from './flags-icons/indonesia.svg';
import it from './flags-icons/italy.svg';
import jp from './flags-icons/japan.svg';
import kz from './flags-icons/kazakhstan.svg';
import kr from './flags-icons/korean.svg';
import ru from './flags-icons/russia.svg';
import tr from './flags-icons/turkey.svg';
import tm from './flags-icons/turkmenistan.svg';
import ve from './flags-icons/venezuela.svg';
import ar from './flags-icons/argentina.svg';
import bo from './flags-icons/bolivia.svg';
import cl from './flags-icons/chile.svg';
import co from './flags-icons/colombia.svg';
import cr from './flags-icons/costa-rica.svg';
import ec from './flags-icons/ecuador.svg';
import gt from './flags-icons/guatemala.svg';
import hn from './flags-icons/honduras.svg';
import mx from './flags-icons/mexico.svg';
import ni from './flags-icons/nicaragua.svg';
import pa from './flags-icons/panama.svg';
import py from './flags-icons/paraguay.svg';
import pe from './flags-icons/peru.svg';
import pr from './flags-icons/puerto-rico.svg';
import es from './flags-icons/spain.svg';
import uy from './flags-icons/uruguay.svg';
import si from './flags-icons/slovenia.svg';
import br from './flags-icons/brazil.svg';
import lv from './flags-icons/latvia.svg';
import lt from './flags-icons/lithuania.svg';
import mk from './flags-icons/macedonia.svg';
import my from './flags-icons/malasia.svg';
import mt from './flags-icons/malta.svg';
import md from './flags-icons/moldova.svg';
import no from './flags-icons/norway.svg';
import pl from './flags-icons/poland.svg';
import pt from './flags-icons/portugal.svg';
import ro from './flags-icons/romania.svg';
import rs from './flags-icons/serbia.svg';
import sk from './flags-icons/slovakia.svg';
import ba from './flags-icons/bosnia-and-herzegovina.svg';
import bw from './flags-icons/botswana.svg';
import se from './flags-icons/sweden.svg';
import th from './flags-icons/thailand.svg';
import ua from './flags-icons/ukraine.svg';
import zw from './flags-icons/zimbabwe.svg';
import vn from './flags-icons/vietnam.svg';
import india from './flags-icons/india.svg';
import dominican from './flags-icons/dominican-republic.svg';
import sv from './flags-icons/el-salvador.svg';
import mo from './flags-icons/macau.svg';
import wls from './flags-icons/wales.svg';
import moh from './flags-icons/mohawk.svg';
import ku from './flags-icons/kurdistan.svg';
import bs from './flags-icons/bahamas.svg';
import ck from './flags-icons/cook-islands.svg';
import sc from './flags-icons/seychelles.svg';
import bn from './flags-icons/bangladesh.svg';

const flags = {
  al,
  za,
  arl,
  dz,
  bh,
  eg,
  iq,
  jo,
  kw,
  lb,
  ly,
  ma,
  om,
  qa,
  sa,
  sy,
  eu,
  tn,
  ae,
  ye,
  hk,
  hr,
  cn,
  sg,
  tw,
  by,
  bg,
  est,
  us,
  au,
  bz,
  ca,
  ie,
  jm,
  gb,
  nz,
  be,
  cz,
  dk,
  nl,
  tt,
  fi,
  af,
  ee,
  ir,
  fr,
  pk,
  tj,
  uz,
  lu,
  at,
  de,
  gr,
  hu,
  is,
  il,
  li,
  gd,
  ch,
  am,
  az,
  ge,
  id,
  it,
  jp,
  kz,
  kr,
  ru,
  tr,
  tm,
  ve,
  ar,
  bo,
  cl,
  co,
  cr,
  ec,
  gt,
  hn,
  mx,
  ni,
  pa,
  py,
  pe,
  pr,
  es,
  uy,
  si,
  br,
  lv,
  lt,
  mk,
  my,
  mt,
  md,
  no,
  pl,
  pt,
  ro,
  rs,
  sk,
  ba,
  bw,
  se,
  th,
  ua,
  zw,
  vn,
  sv,
  in: india,
  do: dominican,
  mo,
  wls,
  moh,
  ku,
  bs,
  ck,
  sc,
  bn,
};

export const flagsList = Object.keys(flags);
export default flags;
